import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/rootReducer';
import { enBetaFeatures } from 'types/enums';

export const selectUser = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user
);

export const selectUserToken = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user.token
);

export const selectUserIsClubeBlack = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user.isClubeBlack
);

export const selectIsLogged = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user.isLogged
);

export const selectHasBetaFeaturePermission = createSelector(
  ({ user }: RootState, feature: enBetaFeatures) => ({ user, feature }),
  ({ user, feature }) => user.betaFeatures?.includes(feature)
);

export const selectIsLoadingAccount = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user.isLoading
);

export const selectShowSurvey = createSelector(
  ({ user }: RootState) => ({ user }),
  ({ user }) => user.showSurvey
);
